import { call, put, takeLatest, all } from 'redux-saga/effects';
import { DEVICE_GROUP_SEARCH } from '../actions/deviceGroup/action_types';
import * as apiErrorActions from 'redux/actions/apiError';
import * as deviceGroupService from '../services/deviceGroup';
import * as listActions from 'redux/actions/list';

function* search() {
  yield takeLatest(DEVICE_GROUP_SEARCH, function*(action) {
    try {
      let deviceGroups = yield call(deviceGroupService.search, action.payload);
      yield put(listActions.listLoaded(deviceGroups));
    } catch (err) {
      yield apiErrorActions.handle(err);
    }
  });
}

export default function* storeGroupSagas() {
  yield all([search()]);
}
